import { Controller } from '@hotwired/stimulus';

export default class CoursesFilterPillsController extends Controller {
  static targets = ['pillsSection', 'clear', 'search'];

  connect () {
    this.update();
  }

  update () {
    this.pillsSectionTarget.innerHTML = '';
    const params = window.location.search.length === 0 ? window.location.hash.split('&') : window.location.search.split('&');

    params.forEach((param) => {
      if (param.includes('school_ids')) { this.updatePills(param, 'sidebar-school'); }
      if (param.includes('program_types')) { this.updatePills(param, 'sidebar-program-type'); }
      if (param.includes('start_dates')) { this.updatePills(param, 'sidebar-start-date'); }
      if (param.includes('topics')) { this.updatePills(param, 'sidebar-topic'); }
      if (param.includes('languages')) { this.updatePills(param, 'sidebar-language'); }
      if (param.includes('search')) { this.updateSearch(param); }
    });

    this.clearTarget.hidden = this.pillsSectionTarget.innerHTML === '';
  }

  delete (event) {
    // to be changed when we update to Stimulus 3 to use action-parameters
    const target = event.target.dataset['enterpriseAdmin-CoursesFilterPillsTargetParam'];
    document.getElementById(target).click();
    event.target.parentNode.remove();
  }

  deleteAll () {
    this.pillsSectionTarget.innerHTML = '';
  }

  updatePills (param, elementId) {
    const index = param.indexOf('=');
    const stringOfValues = param.substring(index + 1, param.lenght);
    if (stringOfValues) {
      const values = stringOfValues.split('%2C');
      values.forEach((value) => {
        if (value) {
          const pillText = document.getElementById(`${elementId}-${value}`).nextElementSibling.innerHTML;
          const target = `${elementId}-${value}`;
          if (pillText) {
            this.createPill(pillText, target);
          }
        }
      });
    }
  }

  updateSearch (param) {
    const text = param.split('=')[1];
    this.searchTarget.value = decodeURIComponent(text).replaceAll('+', ' ');
  }

  createPill (text, targetElement) {
    const span = document.createElement('span');
    span.innerHTML = text;
    span.classList.add('filters__pill');
    const button = document.createElement('button');
    button.innerHTML = '&times;';
    button.classList.add('filters__clear');
    button.setAttribute('data-action', 'enterprise-admin--courses-filter-pills#delete');
    button.setAttribute('data-enterprise-admin--courses-filter-pills-target-param', targetElement);
    span.appendChild(button);
    this.pillsSectionTarget.appendChild(span);
  }
}
